export default __webpack_public_path__ + "static/media/add-icon.117e5d4b.svg";